const problems = [
  {
    icon: 'ri-hand-sanitizer-line',
    title: 'Touching Waste Through Bags',
    desc: 'Thin bags offer little protection. It\'s gross, and you know it.',
  },
  {
    icon: 'ri-emotion-unhappy-line',
    title: 'Awkward & Embarrassing',
    desc: 'Fumbling with bags in public is never a good look. There\'s a better way.',
  },
  {
    icon: 'ri-time-line',
    title: 'Slow & Frustrating',
    desc: 'Wrangling a bag every single walk adds up. Your time is worth more than that.',
  },
];

const solutions = [
  { icon: 'ri-check-line', title: 'Quick one-motion scoop', desc: 'Squeeze, scoop, drop — done in under a second.' },
  { icon: 'ri-check-line', title: 'Zero hand contact', desc: 'Sealed claw mechanism — completely hands-free.' },
  { icon: 'ri-check-line', title: 'Fast & discreet', desc: 'Done in seconds, looks clean and professional.' },
  { icon: 'ri-check-line', title: 'Works everywhere', desc: 'Grass, gravel, pavement — no surface is a problem.' },
];

export default function ProblemSolution() {
  return (
    <section id="problem" className="py-14 md:py-32 bg-[#F8F6F3]">
      <div className="max-w-6xl mx-auto px-6 md:px-10">

        {/* Problem */}
        <div className="text-center mb-10 md:mb-16">
          <span className="text-[#8A9B85] text-xs font-bold uppercase tracking-widest">The Problem</span>
          <h2 className="text-3xl md:text-5xl font-bold text-stone-800 mt-3 mb-3 md:mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
            Tired of the Same Old Struggle?
          </h2>
          <p className="text-stone-500 text-base md:text-lg max-w-xl mx-auto">
            Every dog owner knows the feeling. It doesn't have to be this way.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6 mb-12 md:mb-20">
          {problems.map((p) => (
            <div key={p.title} className="bg-white rounded-2xl p-5 md:p-8 flex md:flex-col items-center md:text-center gap-4 md:gap-0 border border-stone-100">
              <div className="w-12 h-12 md:w-16 md:h-16 flex items-center justify-center bg-[#F5EDE4] rounded-full flex-shrink-0 md:mx-auto md:mb-5">
                <i className={`${p.icon} text-xl md:text-2xl text-[#C4956A]`}></i>
              </div>
              <div>
                <h3 className="text-stone-800 font-bold text-base md:text-lg mb-1 md:mb-2">{p.title}</h3>
                <p className="text-stone-500 text-sm leading-relaxed">{p.desc}</p>
              </div>
            </div>
          ))}
        </div>

        {/* Solution */}
        <div className="text-center mb-8 md:mb-12">
          <span className="text-[#8A9B85] text-xs font-bold uppercase tracking-widest">The Solution</span>
          <h2 className="text-3xl md:text-5xl font-bold text-stone-800 mt-3 mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
            One Tool Changes Everything
          </h2>
        </div>

        <div className="bg-white rounded-3xl overflow-hidden border border-stone-100">
          <div className="flex flex-col md:flex-row">
            <div className="hidden md:block md:w-1/2">
              <img
                src="https://public.readdy.ai/ai/img_res/edited_1a467bda1940dbbfe899a94cfbc7c5a6_ef62cdb8.jpg"
                alt="Using the Pawzly scooper"
                className="w-full h-full object-cover object-top min-h-[300px]"
              />
            </div>
            <div className="md:w-1/2 p-7 md:p-14 flex flex-col justify-center">
              <h3 className="text-xl md:text-2xl font-bold text-stone-800 mb-6 md:mb-8" style={{ fontFamily: "'Playfair Display', serif" }}>
                The Pawzly Scooper
              </h3>
              <div className="flex flex-col gap-4 md:gap-5">
                {solutions.map((s) => (
                  <div key={s.title} className="flex items-start gap-4">
                    <div className="w-7 h-7 flex items-center justify-center bg-[#E8EDE6] rounded-full flex-shrink-0 mt-0.5">
                      <i className="ri-check-line text-[#8A9B85] text-sm font-bold"></i>
                    </div>
                    <div>
                      <p className="text-stone-800 font-semibold text-base">{s.title}</p>
                      <p className="text-stone-500 text-sm mt-0.5">{s.desc}</p>
                    </div>
                  </div>
                ))}
              </div>
              <a
                href="#product"
                className="mt-7 md:mt-10 inline-flex items-center gap-2 bg-[#C4956A] hover:bg-[#b5845a] text-white font-bold px-7 py-3.5 rounded-full transition-colors whitespace-nowrap cursor-pointer self-start"
              >
                Shop Now — $18
                <i className="ri-arrow-right-line"></i>
              </a>
            </div>
          </div>
        </div>

      </div>
    </section>
  );
}
